const layout = {
	header: {
		showShadow: false,
		showNavButton: {
			B2B: true,
			B2C: false,
		},
		showContactButton: {
			B2B: false,
			B2C: true,
		},
		showLangSelector: {
			B2B: false,
			B2C: false,
		},
	},
};

export default layout;
